module.exports = __webpack_public_path__ + "img/teamImg11.e31746dd.jpg";